import { c as config } from './config.js';
import { A as Api } from './Api.js';

class BusinessService {
    async fetchBusiness(businessId, authToken) {
        const endpoint = `entities/business/${businessId}`;
        return Api({ authToken, apiOrigin: config.proxyApiOrigin }).get(endpoint);
    }
    async patchBusiness(authToken, businessId, payload) {
        const endpoint = `entities/business/${businessId}`;
        return Api({ authToken, apiOrigin: config.proxyApiOrigin }).patch(endpoint, payload);
    }
}
class IdentityService {
    async fetchIdentity(identityId, authToken) {
        const endpoint = `entities/identity/${identityId}`;
        return Api({ authToken, apiOrigin: config.proxyApiOrigin }).get(endpoint);
    }
    async patchIdentity(authToken, identityId, payload) {
        const endpoint = `entities/identity/${identityId}`;
        return Api({ authToken, apiOrigin: config.proxyApiOrigin }).patch(endpoint, payload);
    }
    async postIdentity(authToken, payload) {
        const endpoint = `entities/identity`;
        return Api({ authToken, apiOrigin: config.proxyApiOrigin }).post(endpoint, payload);
    }
}

export { BusinessService as B, IdentityService as I };
